/* @flow */
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import tooltipable from 'lib/tooltipable';
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import LinkBase from 'components/LinkBase.jsx';
import userAgent from 'lib/currentUserAgent';

import './styles/Link.scss';

class Link extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    bar: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.oneOf([
      'lava',
      'jungle',
      'shamrock',
      'brand',
      'violet',
      'pitch',
      'eclipse',
      'thunder',
      'white',
      'inherit',
      'sunrise',
    ]),
    underline: PropTypes.bool,
    weight: PropTypes.oneOf(['normal', 'semibold']),
    disabled: PropTypes.bool,
    block: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['inline'])]),
    noWrap: PropTypes.bool,
    noHover: PropTypes.bool,
    rel: PropTypes.string,
    target: PropTypes.string,
    eventElementName: PropTypes.string,
    eventKey: PropTypes.string,
    eventScreenName: PropTypes.string,
    ...LinkBase.propTypes,
  };

  static propClasses = {
    color: {
      lava: 'Link-lava',
      jungle: 'Link-jungle',
      shamrock: 'Link-shamrock',
      brand: 'Link-brand',
      violet: 'Link-violet',
      pitch: 'Link-pitch',
      eclipse: 'Link-eclipse',
      thunder: 'Link-thunder',
      white: 'Link-white',
      inherit: 'Link-inherit',
      sunrise: 'Link-sunrise',
    },
    noWrap: 'Link--noWrap',
    noHover: 'Link--noHover',
    underline: 'Link--underline',
    weight: {
      normal: 'Link--normal',
      semibold: 'Link--semibold',
    },
  };

  render() {
    const { bar, block, disabled, children, className, rel, target, ...props } = this.props;
    const targetBlankRel = (() => {
      let baseRel = 'noopener';
      if (!userAgent.noreferrerSupported()) {
        baseRel += ' noreferrer';
      }
      return baseRel;
    })();
    let safeRel = null;

    if (rel && target === '_blank') {
      safeRel = `${rel} ${targetBlankRel}`;
    } else if (target === '_blank') {
      safeRel = targetBlankRel;
    }

    return (
      <ClickEventTrigger
        eventElementName={this.props.eventElementName}
        eventKey={this.props.eventKey}
        eventScreenName={this.props.eventScreenName}>
        <LinkBase
          {...props}
          rel={safeRel}
          target={target}
          className={cx(
            'Link',
            {
              'Link-bar': bar,
              'Link-disabled': disabled,
              'Link-block': block === true,
              'Link-inlineBlock': block === 'inline',
            },
            getPropClassesFromInstance(this),
            className
          )}
          disabled={disabled}>
          {children}
        </LinkBase>
      </ClickEventTrigger>
    );
  }
}

export { Link };
export default tooltipable(Link);
